import { Store } from "../types";
import * as API from "../../axios/fileTypes";
import { StateCreator } from "zustand";

export const fileTypesSlice: StateCreator<Store, [], [], Store["fileTypes"]> = (set, get) => ({
  createFileType: (payload) => API.createNewEntity(payload),
});
